import {
  ACTION_MAP,
  STORE_URLS,
  APP_URI_SCHEME,
  ANDROID_PACKAGE,
  APP_OPEN_TIMEOUT_MS,
} from "./actionConfig";

export function detectPlatform() {
  const ua = navigator.userAgent || navigator.vendor || "";
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios";
  if (/android/i.test(ua)) return "android";
  return "desktop";
}

export function parseDeepLinkUrl(pathname, search = "") {
  const parts = pathname.replace(/^\//, "").split("/");
  const [, orgId, locationId, actionKey, appId, tillNo, ...extraParams] = parts;
  const action = ACTION_MAP[actionKey] || null;
  const queryParams = new URLSearchParams(search);
  return { orgId, locationId, actionKey, appId, tillNo, extraParams, queryParams, action, raw: parts };
}

/**
 * Builds the full original QR URL to pass into the app.
 * e.g. https://action.rewardstick.com/rewardstick/{OrgID}/{LocationID}/{ActionKey}/{AppID}/{TillNo}
 */
export function buildOriginalUrl() {
  return window.location.href;
}

/**
 * Builds the URI that opens the app, passing the full original URL as a param.
 * Format: rewardstick://open?url={encodedFullUrl}
 */
export function buildAppUri() {
  const encodedUrl = encodeURIComponent(buildOriginalUrl());
  return `${APP_URI_SCHEME}://open?url=${encodedUrl}`;
}

/**
 * Builds the Android Intent URL, passing the full original URL as a param.
 */
export function buildAndroidIntentUrl() {
  const encodedUrl = encodeURIComponent(buildOriginalUrl());
  return (
    `intent://open?url=${encodedUrl}#Intent;` +
    `scheme=${APP_URI_SCHEME};` +
    `package=${ANDROID_PACKAGE};` +
    `S.browser_fallback_url=${encodeURIComponent(STORE_URLS.android)};` +
    `end`
  );
}

export function executeDeepLink(parsed, onRedirecting) {
  const platform = detectPlatform();

  if (platform === "android") {
    onRedirecting({ platform, destination: "app_or_store" });
    window.location.href = buildAndroidIntentUrl();

  } else if (platform === "ios") {
    onRedirecting({ platform, destination: "app_attempting" });
    window.location.href = buildAppUri();

    const timer = setTimeout(() => {
      onRedirecting({ platform, destination: "store" });
      window.location.href = STORE_URLS.ios;
    }, APP_OPEN_TIMEOUT_MS);

    document.addEventListener("visibilitychange", () => {
      if (document.hidden) clearTimeout(timer);
    }, { once: true });

  } else {
    onRedirecting({ platform, destination: "desktop" });
  }
}
